<template>
  <div class="header">
    <CNuxtImg
      class="header__logo sensitive_content"
      src="/images/logo.webp"
      alt="header-logo"
      min-height="28px"
    />
    <p class="header__text" v-html="t('logo_text')"></p>
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n();
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 28px;
  padding: 24px;

  @media (min-width: 374px ) {
    padding-left: 32px;
    padding-right: 32px;
  }
  @media (min-width: 600px ) {
    max-width: 600px;
    margin: 0 auto;
  }

  &__logo {
    width: 28px;
  }
}
</style>

<style lang="scss">
.header__text {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.70);
  font-style: normal;
  font-weight: 500;
  line-height: 120%;

  b {
    color: $text-color;
  }
}
</style>
